import { createFileRoute, notFound } from "@tanstack/react-router";
import shopStyles from "../styles/shop.css?url";
import { ProductPage } from "../components/shop/product-page";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadProduct } from "../server/shop";

/** One product (/merch/products/:slug), from the public listing. */
export const Route = createFileRoute("/merch/products/$slug")({
  loader: async ({ params }) => {
    const product = await loadProduct({ data: params.slug });
    if (!product) throw notFound();
    return product;
  },
  head: ({ matches, loaderData, params }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: `/merch/products/${params.slug}`,
        title: loaderData.head.title,
        description: loaderData.head.description,
        image: loaderData.head.image,
      }),
      shopStyles,
    );
  },
  component: Product,
});

function Product() {
  const product = Route.useLoaderData();
  // Each product gets its own markup for the product script.
  return <ProductPage key={product.id} product={product} />;
}
